import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { CHAPROOM_POSTAGE_METHOD_OPTIONS } from '../../../company/features';
import { PANEL_PRIMARY_BTN_CLASS } from '../../../constants/ui';

/**
 * مدال اختیاری کد رهگیری / نحوه ارسال قبل از انتقال به «بسته بندی و ارسال»
 */
const ChaproomPackagingShippingModal = ({
  open,
  confirmLoading = false,
  onCancel,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    await onSubmit?.({
      trackingCode: values.trackingCode?.trim?.() || values.trackingCode || '',
      postageMethod: values.postageMethod || '',
    });
  };

  return (
    <Modal
      open={open}
      title={<span style={{ fontFamily: 'CustomFont' }}>اطلاعات ارسال</span>}
      onCancel={confirmLoading ? undefined : onCancel}
      onOk={handleOk}
      okText="تأیید و تغییر وضعیت"
      cancelText="انصراف"
      confirmLoading={confirmLoading}
      destroyOnClose
      centered
      okButtonProps={{ className: PANEL_PRIMARY_BTN_CLASS }}
      styles={{ body: { fontFamily: 'CustomFont' } }}
    >
      <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 leading-6">
        در صورت تمایل کد رهگیری و نحوه ارسال را وارد کنید.
      </p>
      <Form form={form} layout="vertical" style={{ fontFamily: 'CustomFont' }}>
        <Form.Item name="trackingCode" label="کد رهگیری">
          <Input placeholder="کد رهگیری" allowClear style={{ fontFamily: 'CustomFont' }} />
        </Form.Item>
        <Form.Item name="postageMethod" label="نحوه ارسال">
          <Select
            allowClear
            placeholder="انتخاب نحوه ارسال"
            options={CHAPROOM_POSTAGE_METHOD_OPTIONS}
            style={{ fontFamily: 'CustomFont' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChaproomPackagingShippingModal;
